// ─── Where the SEC sync stands for a symbol (21/10/2026) ────────────────────
//
// public.sec_sync_status, written by netlify/functions/sec-onboard.js
// (migrations/sec_sync_status.sql). The financials and profile panels read it
// when they have no data, so the empty state says what is true:
//   not synced yet, or still running → "בטעינה"
//   the last attempt failed          → "לא הצלחנו למשוך את הדוחות · ננסה שוב בשעה הקרובה"
//   not in SEC's ticker directory    → "לא נמצאו דוחות ב-SEC EDGAR עבור <סמל>"
// Never "the company does not file": the app does not know that.
import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

// The row, or null (no row, the table not created yet, or a failed read ·
// all of which read as "not synced yet").
export async function fetchSecStatus(symbol) {
  if (!supabase || !symbol) return null;
  const { data, error } = await supabase.from("sec_sync_status")
    .select("symbol, state, attempts, last_attempt_at, last_ok_at").eq("symbol", symbol).maybeSingle();
  if (error) return null;
  return data || null;
}

/** → { kind: "loading" | "failed" | "not_found", line, sub } */
export function secEmptyState(status) {
  if (status?.state === "not_found") {
    return { kind: "not_found", line: "לא נמצאו דוחות ב-SEC EDGAR עבור", sub: "הסמל לא מופיע ברשימת החברות המדווחות של SEC. תעודת סל, למשל, אינה מגישה דוחות כאלה." };
  }
  if (status?.state === "failed") {
    return { kind: "failed", line: "לא הצלחנו למשוך את הדוחות", sub: "ננסה שוב בשעה הקרובה" };
  }
  return { kind: "loading", line: "הדוחות בטעינה", sub: "הדוחות נמשכים מ-SEC EDGAR, בדרך כלל בתוך שעה מהוספת המניה לתיק או לרשימת המעקב." };
}

// The status for a symbol, read only when the panel has no data to show
// (`needed`). undefined while it loads, then the row or null.
export function useSecStatus(symbol, needed) {
  const [status, setStatus] = useState(undefined);
  useEffect(() => {
    if (!needed || !symbol) { setStatus(undefined); return undefined; }
    let alive = true;
    fetchSecStatus(String(symbol).toUpperCase()).then(r => { if (alive) setStatus(r); }).catch(() => { if (alive) setStatus(null); });
    return () => { alive = false; };
  }, [symbol, needed]);
  return status;
}
